import React, { useEffect, useState, useCallback } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { red } from '@material-ui/core/colors';
import { CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isUndefined } from 'lodash';

import { uploadContentService } from '../../../services';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: '#252525',
    color: red[50],

  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  },

}));


export default function CheckboxList({ playlists, id }) {
  const classes = useStyles();
  const [checked, setChecked] = useState([0]);
  const [selectedList, setSelectedList] = useState([]);
  const [dynamicPlaylistsDetail, setDynamicPlaylistsDetail] = useState([]);
  const [idDetail, setIdDetail] = useState([]);
  const [contentDetail, setContentDetail] = useState([]);
  const { user } = useSelector(state => state.userAuthentication);


  //get the data of the id that is passed from scheduleModal.js
  const getDynamicPlaylistsDetails = useCallback(async (value) => {

    if (!isUndefined(user)) {
      const res = await uploadContentService.dynamicContentPlaylistDetail(user, value);
      if (!isUndefined(res)) {
        setDynamicPlaylistsDetail(dynamicPlaylistsDetail => [...dynamicPlaylistsDetail, res])
        setIdDetail(idDetail => [...idDetail, res['id']])
        setContentDetail(response => [...response, res['content']])

      }
    }
  }, [user]);


  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    let selected = selectedList;
    let find = selected.indexOf(value.id)

    if (currentIndex === -1) {
      getDynamicPlaylistsDetails(value.id);
      selected.push(value.id);
      newChecked.push(value);
      localStorage.setItem("content", (contentDetail));
      localStorage.setItem("id", (idDetail));
      localStorage.setItem("dynamicPlaylistsDetail", JSON.stringify(dynamicPlaylistsDetail));

    } else {
      selected.splice(find, 1);
      newChecked.splice(currentIndex, 1);

    }
    setChecked(newChecked);

  };

  useEffect(() => {
    localStorage.setItem("content", JSON.stringify(contentDetail));
    localStorage.setItem("id", JSON.stringify(idDetail));
    /*  cookies.set('contentPlaylistData', JSON.stringify(dynamicPlaylistsDetail), { path: '/' });
      console.log(dynamicPlaylistsDetail); */
    //localStorage.setItem("dynamicPlaylistsDetail", JSON.stringify(dynamicPlaylistsDetail));
    /* if (!isUndefined(contentDetail) && !isNull(contentDetail)) {
     
    } */
  }, [dynamicPlaylistsDetail]);


  return (
    <List className={classes.root} >
      {!isUndefined(playlists) ? (
        [...playlists].map((value) => {
          const labelId = `checkbox-list-label-${value}`;
          return (
            <ListItem key={value.id} role={undefined}
              dense
              button
              onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText className={classes.colorChange} id={labelId}> {value.name}
                <pre></pre>
              </ListItemText>
            </ListItem>
          );
        })
      ) : (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      )}
    </List>
  );
}
